import React from 'react';
import { Box } from '@saucelabs/sl-component-grid';

import Styles from './SubscriptionBoxes.styles';

interface SubscriptionBoxProps {
  children: React.ReactNode
}
const SubscriptionBox: React.FC<SubscriptionBoxProps> & { Section: React.FC } = ({ children }) => (
  <Box className={`p-2 w-full ${Styles.box}`}>{children}</Box>
);

SubscriptionBox.Section = ({ children }) => (
  <div className="box-section">{children}</div>
);

export { SubscriptionBox };
